module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "svg-map"
  }, [(_vm.bg) ? _c('div', {
    staticClass: "svg-map-bg",
    domProps: {
      "innerHTML": _vm._s(_vm.svg(_vm.bg))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "svg",
    staticClass: "svg-map-src",
    domProps: {
      "innerHTML": _vm._s(_vm.svg(_vm.src))
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-05701e0c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05701e0c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SvgMap.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-05701e0c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SvgMap.vue
// module chunks = 0